/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MessageModel } from './messageModel';
import { WorkflowModel } from './workflowModel';


/**
 * Select inactive offices to renew response type
 */
export class SelectInactiveOfficesToRenewResponseModel { 
    Workflow?: WorkflowModel;
    /**
     * Flag instructing portal application to reset ADRE session information by calling GetHomePage service and returning the user to the home page
     */
    ResetSession?: boolean;
    /**
     * Enumerated value with the following options: 0 = Success, 1 = Retry, 2 = Stop
     */
    Summary?: SelectInactiveOfficesToRenewResponseModel.SummaryEnum;
    /**
     * System message to clarify a response to the web portal application. Not intended to be displayed to the user
     */
    SystemMessage?: string;
    /**
     * List of messages to be displayed using Bootstrap Alerts to the user
     */
    UserMessages?: Array<MessageModel>;
}
export namespace SelectInactiveOfficesToRenewResponseModel {
    export type SummaryEnum = 0 | 1 | 2;
    export const SummaryEnum = {
        NUMBER_0: 0 as SummaryEnum,
        NUMBER_1: 1 as SummaryEnum,
        NUMBER_2: 2 as SummaryEnum
    };
}



// WEBPACK FOOTER //
// ./src/app/model/selectInactiveOfficesToRenewResponseModel.ts